import { FC, useRef } from 'react';
import { SvgIcon, Typography } from '@mui/material';

import { ReactComponent as IconWeChat } from 'src/assets/svg/wechat-logo.svg';

import { appConfig } from '../../../app/app-config';

import { ContactUsButton } from './contact-us-button';

export const WechatButton: FC = () => {
    const Icon = useRef(
        <SvgIcon>
            <IconWeChat />
        </SvgIcon>
    );

    return (
        <ContactUsButton icon={Icon.current} href={appConfig.contacts.weChatUrl} newTab>
            <Typography>WeChat</Typography>
        </ContactUsButton>
    );
};
